import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ProgressButton from '../../../commons/ProgressButton';

// 0 -> Felvitel
// 1 -> módosítás
let _muvelet = 0;
let _modositoObj = null;

class Jogalap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ['QUERY', 'LOAD', 'DATA', 'NETW', 'TABL']
      currentStatusBaseTable: 'LOAD',
      modalNezet: false,
      modalFelvitel: false,
      modalTorles: false,
      dataLoaded: false,
      dataFailed: false,
      baseJson: [],
      /*
       *  FORM VALUES
       */
      nev: '',
      kod: '',
      statusz: '',
      elevules: '',
      szoveg: '',
      jogszabalyiHivatkozas: '',

      statuszok: [],
      statuszOptions: [],
      filterOptions: {},
      viewObj: null,

      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };

    this.updateTable = this.updateTable.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateTable();
      }
    }
  }

  updateTable = () => {
    this.setState({
      currentStatusBaseTable: 'LOAD'
    });
    Services.listJogalap((err, res) => {
      if (err) {
        this.setState({
          currentStatusBaseTable: 'NETW'
        });
      } else {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });
        this.setState({
          baseJson: res[0].list,
          currentStatusBaseTable: res[0].list.length > 0 ? 'TABL' : 'DATA',
          statuszok: res[0].statusz,
          statuszOptions: options,
          filterOptions: filters,
        });
      }
    });
  }

  fillModositoObj = () => {
    this.setState({ modifyDataLoaded: false, modfiyDataFailed: false });
    Services.getJogalap(this._currentEditId, (err, res) => {
      if (err) {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: true });
      } else {
        this.setState({
          kod: res[0].kod,
          nev: res[0].nev,
          szoveg: res[0].szoveg,
          jogszabalyiHivatkozas: res[0].jogszhiv,
          statusz: res[0].statusz,
          elevules: res[0].elevules + '',
        }, () => {
          this.toggleModositas();
        });
      }
    });
  }

  clearModositoObj = () => {
    _modositoObj = {
      id: '',
      ev: '',
      tipus: '',
      mertek: '',
      statusz: '',
    };
  }

  toggleNezet = () => {
    this.setState({ modalNezet: !this.state.modalNezet });
  }

  toggleModositas = () => {
    this.setState({
      modalFelvitel: !this.state.modalFelvitel
    });
  }

  toggleFelvitel = () => {
    this.setState({
      nev: '',
      kod: '',
      statusz: '',
      elevules: '',
      szoveg: '',
      jogszabalyiHivatkozas: '',
      modalFelvitel: !this.state.modalFelvitel
    });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  handleEditClick = (id) => {
    _muvelet = 1;
    this._currentEditId = id;
    this.fillModositoObj();
  }

  handleNewClick = () => {
    _muvelet = 0;
    this.clearModositoObj();
    this.toggleFelvitel();
    this.setState({ statusz: 'AKTIV' });
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  handleViewClick = (id) => {
    this._currentViewId = id;
    this.viewJogalap();
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        {this.props.globals.hasRole(['GDPR_JOGALAP']) && 
        <>
          <Button className="icon-eye table-action-icon" id={'action-view-' + cell} onClick={() => this.handleViewClick(cell)} />
          <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-view-' + cell} delay={10}>
            {'Megtekintés'}
          </UncontrolledTooltip>
        </>
        }
        { 
          this.props.globals.hasRole(['GDPR_JOGALAP'], true) && 
          (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell} onClick={() => this.handleEditClick(cell, row)} />
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-edit-' + cell} delay={10}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-delete-' + cell} delay={10}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  felhasznalvaFormatter = (cell) => {
    return cell ? 'Igen' : 'Nem';
  }

  addJogalap = () => {
    let submitObj = {
      kod: this.state.kod,
      nev: this.state.nev,
      szoveg: this.state.szoveg,
      jogszabalyiHivatkozas: this.state.jogszabalyiHivatkozas,
      elevules: this.state.elevules,
      statusz: this.state.statusz
    };
    this.setState({ addButtonLoading: true });
    Services.addJogalap(submitObj, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Jogalap felvéve!');
      }
      this.setState({ addButtonLoading: false });
    });
  }

  viewJogalap = () => {
    Services.viewJogalap(this._currentViewId, (err, res) => {
      if (!err) {
        this.setState({ viewObj: res[0] }, () => { this.toggleNezet(); });
      }
    });
  }

  updateJogalap = () => {
    let submitObj = {
      id: this._currentEditId,
      kod: this.state.kod,
      nev: this.state.nev,
      szoveg: this.state.szoveg,
      jogszabalyiHivatkozas: this.state.jogszabalyiHivatkozas,
      elevules: this.state.elevules,
      statusz: this.state.statusz
    };
    this.setState({ modifyButtonLoading: true });
    Services.editJogalap(submitObj, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Jogalap módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteJogalap = (id) => {
    this.toggleTorles();
    this.setState({ deleteButtonLoading: true });
    Services.deleteJogalap(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Jogalap törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  filterType = (cell) => {
    // just return type for filtering or searching.
    return cell.caption;
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statuszok.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  renderBaseTable = () => {
    const pagination = true;
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ],
    };

    const columns = [
      {
        dataField: 'kod',
        text: 'Kód',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal', width: 130 },
      },
      {
        dataField: 'nev',
        text: 'Megnevezés',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'szoveg',
        text: 'Szöveg',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'jogszhiv',
        text: 'Jogszabályi hivatkozás',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'statusz',
        text: 'Státusz',
        formatter: this.statusFormatter,
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
        }),
        style: { whiteSpace: 'normal', width: 150 },
        align: 'center'
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter,
        style: { width: 100 },
      },
    ];

    return (
      <BootstrapTable
        bootstrap4
        keyField="id"
        columns={columns}
        data={this.state.baseJson}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
    );
  }

  renderAdatok = () => {
    return (
      <div>
        <h6>
          {'Jogalap információ:'}
        </h6>
        <b>
          {'Kód:'}
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.kod}
        <br />
        <b>
          {'Megnevezés:'}
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.nev}
        <br />
        <b>
          {'Szöveg:'}
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.szoveg}
        <br />
        <b>
          {'Jogszabály hivatkozás:'}
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.jogszhiv}
        <br />
        <b>
          {'Státusz:'}
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.statusz}
        <br />
        <b>
          {'Elévülési idő:'}
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.elevules + ' év'}
        <br />
      </div>
    );
  }

  render() {
    return (
      <div>
        { 
          this.props.globals.hasRole(['GDPR_JOGALAP'], true) && 
          (
          <div className="row">
            <div className="col-sm-12">
              <Button
                className="pull-left table-new-button"
                color="primary"
                onClick={this.handleNewClick}
              >
                {'Új jogalap'}
              </Button>
            </div>
          </div>
        )}
        {{
          QUERY: (<QueryEmptyState
            hasImage
          />),
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />),
          TABL: (this.renderBaseTable())
        }[this.state.currentStatusBaseTable]}
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.renderAdatok(this._currentViewId) : <div />}</ModalBody>
          <ModalFooter> <Button type="button" color="primary" onClick={this.toggleNezet} className="btn-cursor-pointer" >Vissza</Button></ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>
            {'Törlés'}
          </ModalHeader>
          <ModalBody>
            {'Valóban törölni kívánod a kiválasztott tételt?'}
          </ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} className="btn-cursor-pointer" color="primary" onClick={() => this.deleteJogalap(this._currentDeleteId)}>
              {'OK'}
            </ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>
              {'Mégsem'}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal size="lg" isOpen={this.state.modalFelvitel} toggle={this.toggleFelvitel} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={_muvelet === 0 ? this.addJogalap : this.updateJogalap}
            title={_muvelet === 0 ? 'Új jogalap rögzítése' : 'Meglévő jogalap módosítása' }
            footer={
                <React.Fragment>
                  <ProgressButton loading={_muvelet === 0 ? this.state.addButtonLoading : this.state.modifyButtonLoading} color="primary">
                  {'Mentés'}
                  </ProgressButton>
                  {' '}
                  <Button type="button" color="secondary" onClick={this.toggleFelvitel}>
                    {'Mégsem'}
                  </Button>
                </React.Fragment>
              }
            >
            <div className="row">
              <div className="col-md-12">
                <RFField
                  type="text"
                  label="Megnevezés: *"
                  name="nev"
                  id="nev"
                  required
                  value={this.state.nev}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  type="text"
                  label="Kód: *"
                  name="kod"
                  id="kod"
                  required
                  disabled={!(_muvelet === 0)}
                  value={this.state.kod}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  type="select"
                  name="statusz"
                  id="statusz"
                  errorMessage="Kötelező mező!"
                  required
                  label="Státusz: *"
                  // defaultValue="false"
                  value={this.state.statusz}
                  onChange={this.handleInputChange}
                  selectOptions={this.state.statuszOptions}
                />
              </div>
              <div className="col-md-4">
                <RFField
                  type="text"
                  label="Elévülési idő (év): *"
                  name="elevules"
                  id="elevules"
                  required
                  value={this.state.elevules}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-12">
                <RFField
                  className="munkalap-profil-textarea"
                  type="textarea"
                  label="Szöveg"
                  name="szoveg"
                  id="szoveg"
                  value={this.state.szoveg}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-12">
                <RFField
                  type="textarea"
                  label="Jogszabályi hivatkozás:"
                  name="jogszabalyiHivatkozas"
                  id="jogszabalyiHivatkozas"
                  value={this.state.jogszabalyiHivatkozas}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </RFForm>
        </Modal>
      </div>
    );
  }
}

export default Jogalap;
